import { store } from '../../../../resources/frontend/js/store/index';

export const zipcodeIsAllowed = (value, listId) => {
    if (!value) return true;

    const zipcodeLists = store.getters['page/getZipcodeListBasedOnId'](listId);

    if (!zipcodeLists) return true;

    value = value.toUpperCase();
    let listsContainsZipcode = false;

    if (zipcodeLists.is_partial) {
        for (const list of zipcodeLists.lists) {
            for (const zipcode of list.zipcodes) {
                if (value.startsWith(zipcode)) {
                    listsContainsZipcode = true;

                    if (list.name) {
                        store.commit('page/setVariable', {key: 'dealership', value: list.name});
                    }

                    break;
                }
            }
        }
    } else {
        for (const list of zipcodeLists.lists) {
            if (list.zipcodes.includes(value)) {
                listsContainsZipcode = true;

                if (list.name) {
                    store.commit('page/setVariable', {key: 'dealership', value: list.name});
                }

                break;
            }
        }
    }

    const allowed = zipcodeLists.type === 'whitelist' ? listsContainsZipcode : !listsContainsZipcode;

    if (!allowed) {
        store.commit('page/setVariable', {key: 'dealership', value: null});
        store.commit('dialog/show', `dialog-zipcode-list-${zipcodeLists.id}`);
    }

    return allowed;
};
